import React, { useState } from 'react'
import useDeliverableMetrics from '../useDeliverableMetrics'
import { SvgIcon, Stack, Typography } from '@mui/material'
import { DonutChartData, UnifiedDonutCharts } from '../../../../../shared/components/DonutCharts'
import { ReactComponent as DeliverableIcon } from '../../../../../assets/images/ClipboardText.svg'
import List from '../../components/List'
import { Deliverable } from '../../../../../shared/queries/metrics/useGetDeliverablesQuery'
import { EmptyPlaceholder } from '../../../../../shared/components/EmptyPlaceholder'

const DeliverablesDonutCharts = () => {
    const { legend, data } = useDeliverableMetrics()

    const [listData, setListData] = useState<DonutChartData<Deliverable>>(null)

    const title = `Deliverables`
    const isEmpty = !data.length

    return (
        <Stack direction="column" flex={1} my={3}>
            <Stack direction="row" alignItems="center" gap={1} color="figma.grayscale.textHier1" mb={1}>
                <SvgIcon
                    component={DeliverableIcon}
                    inheritViewBox
                    fontSize="small"
                    color="inherit"
                    sx={{ fontSize: '24px' }}
                />
                <Typography variant="20x500" color="inherit">
                    {title}
                </Typography>
            </Stack>

            {isEmpty && (
                <Stack
                    flex={1}
                    direction="column"
                    gap={1}
                    px={2}
                    py={2.75}
                    bgcolor="figma.grayscale.tier7"
                    borderRadius="16px"
                >
                    <EmptyPlaceholder title="" subtitle="No data to display" />
                </Stack>
            )}
            {!isEmpty && <UnifiedDonutCharts data={data} legend={legend} onTotalClick={setListData} />}

            <List
                data={listData}
                legend={legend}
                handleClose={() => setListData(null)}
                getName={(activity) => activity.title}
            />
        </Stack>
    )
}

export default DeliverablesDonutCharts
